const state = () => ({
    events: [],
    loading: false,
})

const getters = {}

const actions = {
    async getCalendar({commit}, {year, month} = {}) {
        commit('setLoading', true)
        try {
            const firstDay = new Date(year, month - 1, 1)
            const lastDay = new Date(year, month, 0)

            const rangeStart = new Date(firstDay)
            rangeStart.setDate(rangeStart.getDate() - 7)

            const rangeEnd = new Date(lastDay)
            rangeEnd.setDate(rangeEnd.getDate() + 7)

            const formatDt = (d) => {
                const y = d.getFullYear()
                const m = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                return `${y}-${m}-${day} 00:00:00`
            }

            const res = await this._vm.axios.get(this._vm.endpoints['module_agenda'], {
                params: {
                    page_limit: 9999,
                    'event_at[min]': formatDt(rangeStart),
                    'event_at[max]': formatDt(rangeEnd),
                }
            })

            const events = res.data.data || []
            commit('setEvents', events)
            return events
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async show({commit}, {id}) {
        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_agenda'] + '/' + id)
            return res.data.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async add({commit}, {formData}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['module_agenda'], formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async update({commit}, {id, formData}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.put(this._vm.endpoints['module_agenda'] + '/' + id, formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async updateStatus({commit}, {id, status_id}) {
        try {
            const res = await this._vm.axios.patch(
                this._vm.endpoints['module_agenda_status'],
                {status_id},
                { urlVars: { id } }
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async delete({commit}, {id, deleteScope}) {
        try {
            const url = this._vm.endpoints['module_agenda'] + '/' + id + (deleteScope ? '?delete_scope=' + deleteScope : '')
            const res = await this._vm.axios.delete(url)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.loading = val
    },
    setEvents(state, data) {
        state.events = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
